/*!
 * (C) Phonero UX - ISC License
 */
/** Can be used to set typography-classes for any component */
function createTypographyClasses(variant, ...extras) {
  if (variant) {
    extras.push("typography");
    extras.push(variant);
  }
  return extras.filter(Boolean).join(" ");
}

export { createTypographyClasses as c };
